import { AgentConfig } from '@/types/agent';

export type ChatValidationResult = {
  isDisabled: boolean;
  hasContextVariables: boolean;
  hasAdditionalInputs: boolean;
};

/**
 * Checks if the low-code chat should be disabled based on:
 * 1. Presence of context variables in the config
 * 2. Additional inputs in the start node beyond 'conversation'
 */
export function validateChatAvailability( config: AgentConfig ): ChatValidationResult {
  // Check for context variables
  const hasContextVariables = config.context && Object.keys( config.context ).length > 0;

  // Find the start node and check for additional inputs
  const startNode = config.steps.find( step => step.label === 'start' );
  const hasAdditionalInputs = startNode
    ? Object.keys( startNode.inputs ).some( key => key !== 'conversation' )
    : false;

  return {
    isDisabled: hasContextVariables || hasAdditionalInputs,
    hasContextVariables,
    hasAdditionalInputs
  };
}
